import React, { memo } from "react";
import { CommonDiv, FlexJustCenter } from "../StyledComponents";
import EmptyData from "../StyledComponents/EmptyData";

import {
  Avatar,
  AvatarImage,
  AvatarLetter,
  Badge,
  Card,
  DiscLabel,
  Flexbetween,
  GridContainer,
  Thumpnail,
  TitleLabel,
  UserLabbel,
} from "./Styles";

const GridView = ({ data, handleOpen, size }) => {
  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;
  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0],
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }
  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }

  const B_Url = backurl + "/sites/" + DBhost + "/Education_Files/";

  const File_URL = backurl + "/sites/" + DBhost + "/documentimg/";

  return (
    <GridContainer>
      {data.length !== 0 ? (
        data.map((item, index) => (
          <Card
            onClick={() => handleOpen(item)}
            key={index}
            size={
              size === 1
                ? "100%"
                : size === 2
                  ? "47%"
                  : size === 3
                    ? "30%"
                    : "337px"
            }
          >
            <Thumpnail src={B_Url + item.thumbnailUrl} />
            <Flexbetween>
              <TitleLabel title={item.title}>{item.title}</TitleLabel>
              <Badge>{item.fileType}</Badge>
            </Flexbetween>

            <DiscLabel wordBreak="break-all">{item.description}</DiscLabel>
            <FlexJustCenter margin="4px 16px 12px 16px">
              {item.userUrl ? (
                <AvatarImage src={File_URL + item.userUrl} />
              ) : (
                <Avatar width="28px" height="28px">
                  <AvatarLetter
                    display="flex"
                    justifyContent="center"
                    paddingTop="6px"
                  >
                    {item.UploadedBy.charAt(0).toUpperCase()}
                  </AvatarLetter>
                </Avatar>
              )}
              <UserLabbel>{item.UploadedBy}</UserLabbel>
            </FlexJustCenter>
            {/* <Flexbetween
              padding="8px 16px"
              borderTop="1px solid #EBEAED"
              margin="10px 16px 2px 16px"
            >
              <UserLabbel lineHeight="16px" className="assigned_margin">
                Assigned {item.Assigned}
              </UserLabbel>
              <UserLabbel lineHeight="16px" className="assigned_marginright">
                Watched {item.Watched}
              </UserLabbel>
            </Flexbetween> */}
          </Card>
        ))
      ) : (
        <CommonDiv height="100%" width="100%" flexCenterAll>
          <EmptyData />
        </CommonDiv>
      )}
    </GridContainer>
  );
};

export default memo(GridView);
